"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFRESH_DAILY_TASK = exports.updateCacheOnAddToDailyStack = exports.updateCacheOnRemoveFromDailyStack = exports.REMOVE_FROM_DAILY_STACK = exports.ADD_TO_DAILY_STACK = exports.optimisticSaveTodos = exports.saveTodosCache = exports.optimisticUpdatedSaveTodo = exports.SAVE_TODO = exports.BUILD_TODO = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../../fragments");
const restricted_1 = require("../../query/restricted");
exports.BUILD_TODO = (0, client_1.gql) `
  mutation BuildTodo($buildTodo: BuildTodoInput!) {
    restricted {
      buildTodo(buildTodo: $buildTodo) {
        id
      }
    }
  }
`;
exports.SAVE_TODO = (0, client_1.gql) `
  mutation SaveTodo($todos: [TodoInput!]!) {
    restricted {
      saveTodos(todos: $todos) {
        id
        dailyTask
        source
        marks {
          id
          cardId
          score
          timeTaken
          card {
            question
            explanation
            concept {
              id
              videos {
                id
                title
                museId
                thumbnail
                concepts {
                  id
                  name
                }
                live
                description
                duration
              }
            }
            pictures {
              id
              caption
              path
              thumbhash
              index
            }
          }
        }
      }
    }
  }
`;
const optimisticUpdatedSaveTodo = (todo, cardIndex, todoInput) => {
    const { score, timeTaken } = todoInput;
    const { marks } = todo;
    const newMarks = [...marks];
    newMarks[cardIndex] = { ...marks[cardIndex], score, timeTaken };
    return {
        restricted: {
            saveTodos: [
                {
                    ...todo,
                    marks: newMarks,
                },
            ],
        },
    };
};
exports.optimisticUpdatedSaveTodo = optimisticUpdatedSaveTodo;
function saveTodosCache(cache, result, options) {
    const { saveTodos } = result?.data?.restricted || {};
    if (!options.variables || !saveTodos) {
        return;
    }
    for (let i = 0; i < saveTodos.length; i++) {
        const todoMark = options.variables.todos[i];
        const todoMarkId = saveTodos[i];
        cache.writeFragment({
            id: cache.identify({ id: todoMarkId, __typename: 'TodoMark' }),
            data: {
                score: todoMark.score,
                timeTaken: todoMark.timeTaken || 0,
            },
            fragment: (0, client_1.gql) `
        fragment NewTodoMark on TodoMark {
          score
          timeTaken
        }
      `,
        });
    }
}
exports.saveTodosCache = saveTodosCache;
const optimisticSaveTodos = (todo, cardIndex, todoInput) => {
    const { score, timeTaken } = todoInput;
    const { marks } = todo;
    const newMarks = [...marks];
    newMarks[cardIndex] = { ...marks[cardIndex], score, timeTaken };
    return {
        restricted: {
            saveTodos: [
                {
                    ...todo,
                    marks: newMarks,
                },
            ],
        },
    };
};
exports.optimisticSaveTodos = optimisticSaveTodos;
exports.ADD_TO_DAILY_STACK = (0, client_1.gql) `
  ${fragments_1.PICTURE_FIELDS}
  mutation AddToDailyStack($conceptIds: [Int!]!) {
    restricted {
      addToDailyStack(conceptIds: $conceptIds) {
        addedUserCompletedCards {
          id
          createdAt
          updatedAt
          concept {
            id
            name
          }
          lastSeen
          reviewDate
          score
          iteration
          optimalFactor
          cardId
          card {
            id
            conceptId
            concept {
              id
              name
            }
            topic {
              id
              name
            }
            question
            explanation
            pictures {
              ...PictureFields
            }
          }
        }
        dailyFeed {
          id
          marks {
            id
          }
        }
      }
    }
  }
`;
exports.REMOVE_FROM_DAILY_STACK = (0, client_1.gql) `
  mutation RemoveFromDailyStack($cardId: Int, $todoId: Int, $conceptId: Int) {
    restricted {
      removeFromDailyStack(
        cardId: $cardId
        todoId: $todoId
        conceptId: $conceptId
      ) {
        removedUserCompletedCards {
          id
          cardId
          concept {
            id
            name
          }
        }
        dailyFeed {
          id
          marks {
            id
          }
        }
      }
    }
  }
`;
const updateCacheOnRemoveFromDailyStack = (cache, result, options) => {
    const { removeFromDailyStack: data } = result.data?.restricted || {};
    const { variables } = options || {};
    const { todoId } = variables || {};
    if (!data || !data.removedUserCompletedCards.length) {
        return;
    }
    const toRemove = new Set(data.removedUserCompletedCards.map(({ cardId }) => cardId));
    const prevData = cache.readQuery({
        query: restricted_1.USER_COMPLETED_DATA,
    });
    if (prevData) {
        const newCompletedCards = prevData.restricted.user.completedCards.filter(({ cardId }) => !toRemove.has(cardId));
        cache.writeQuery({
            query: restricted_1.USER_COMPLETED_DATA,
            data: {
                ...prevData,
                restricted: {
                    ...prevData.restricted,
                    user: {
                        ...prevData.restricted.user,
                        completedCards: newCompletedCards,
                        completedCardsCount: newCompletedCards.length,
                        dailyFeed: data.dailyFeed,
                    },
                },
            },
        });
    }
    if (todoId) {
        const prevData = cache.readQuery({
            variables: { id: todoId },
            query: restricted_1.TODO,
        });
        if (prevData) {
            const { marks } = prevData.restricted.todo;
            cache.writeQuery({
                query: restricted_1.TODO,
                data: {
                    ...prevData,
                    restricted: {
                        ...prevData.restricted,
                        todo: {
                            ...prevData.restricted.todo,
                            marks: marks.filter(({ cardId }) => !toRemove.has(Number(cardId))),
                        },
                    },
                },
            });
        }
    }
};
exports.updateCacheOnRemoveFromDailyStack = updateCacheOnRemoveFromDailyStack;
const updateCacheOnAddToDailyStack = (cache, result) => {
    const { addToDailyStack: data } = result.data?.restricted || {};
    const prevData = cache.readQuery({
        query: restricted_1.USER_COMPLETED_DATA,
    });
    if (prevData && data) {
        const newCompletedCards = [
            ...prevData.restricted.user.completedCards,
            ...data.addedUserCompletedCards,
        ];
        cache.writeQuery({
            query: restricted_1.USER_COMPLETED_DATA,
            data: {
                ...prevData,
                restricted: {
                    ...prevData.restricted,
                    user: {
                        ...prevData.restricted.user,
                        completedCards: newCompletedCards,
                        completedCardsCount: newCompletedCards.length,
                        dailyFeed: data.dailyFeed,
                    },
                },
            },
        });
    }
};
exports.updateCacheOnAddToDailyStack = updateCacheOnAddToDailyStack;
exports.REFRESH_DAILY_TASK = (0, client_1.gql) `
  ${fragments_1.PICTURE_FIELDS}
  mutation RefreshDailyTask {
    restricted {
      refreshDailyTask {
        id
        dailyTask
        marks {
          id
          cardId
          card {
            id
            question
            explanation
            pictures {
              ...PictureFields
            }
          }
          score
          timeTaken
        }
        source
      }
    }
  }
`;
